"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_collapsed_1 = __importDefault(require("react-collapsed"));
const classnames_1 = __importDefault(require("classnames"));
const expand_more_md_svg_1 = require("components/svg/icons/expand-more-md.svg");
const prop_types_1 = __importDefault(require("prop-types"));
require("./collapse.scss");
const Collapse = ({ children, onClick, opened, label }) => {
    const { getCollapseProps, getToggleProps } = (0, react_collapsed_1.default)({
        isExpanded: opened
    });
    return ((0, jsx_runtime_1.jsxs)("div", { className: "collapse", children: [(0, jsx_runtime_1.jsx)("button", { "aria-label": label, className: "collapse__header _w-full _d-flex _justify-content-center _align-items-center", ...getToggleProps({
                    onClick
                }), children: (0, jsx_runtime_1.jsx)(expand_more_md_svg_1.ReactComponent, { className: (0, classnames_1.default)('collapse__header__icon', {
                        'collapse__header__icon-closed': !opened,
                        'collapse__header__icon-opened': opened
                    }) }) }), (0, jsx_runtime_1.jsx)("section", { ...getCollapseProps(), children: children })] }));
};
Collapse.propTypes = {
    children: prop_types_1.default.node,
    onClick: prop_types_1.default.func,
    opened: prop_types_1.default.bool
};
exports.default = Collapse;
